export const getCareerItems = (careerData) => [
  {
    label: "Qualification",
    value: careerData?.qualification || null,
  },
  {
    label: "Course",
    value: careerData?.course || null,
  },
  {
    label: "Institution",
    value: careerData?.institution || "",
  },
  {
    label: "Sector",
    value: careerData?.sector || null,
  },
  {
    label: "Employment",
    value: careerData?.employment_type || "",
  },
  {
    label: "Company name",
    value: careerData?.company || "",
  },
  {
    label: "Profession",
    value: careerData?.profession || null,
  },
  {
    label: "Annual Income",
    value: careerData?.annual_income || null,
  },
];
